export default __webpack_public_path__ + "static/media/Dedication.be443e94.txt";